import React from "react";
import { Nav } from "../../Components/index";
import { Footer } from "../../Containers/index";
import classes from "./Contactus.module.css";
import { Map } from "../../Components/index";
// import { Spinner } from "../../Components/UI/index";

// ICONS
import MapIcon from "../../assets/icons/map-pin-line.svg";
import PhoneIcon from "../../assets/icons/phone-call.svg";
import EmailIcon from "../../assets/icons/envelope-simple.svg";

function Contactus() {
  return (
    <section className={classes.Contactus}>
      <Nav />

      <div className={classes.ContactusContent}>
        <h2 className={classes.ContactusTitle}>
          <span>Locate</span> Us
        </h2>
        <p className={classes.Company}>All African Hub</p>
        <ul className={classes.ContactusList}>
          <li className={classes.ContactusListItem}>
            <img
              src={MapIcon}
              alt="Map-pin-line Icon"
              className={classes.ContactusListIcon}
            />
            Location, Addis Ababa
          </li>
          <li className={classes.ContactusListItem}>
            <img
              src={PhoneIcon}
              alt="Phone-call Icon"
              className={classes.ContactusListIcon}
            />
            <a className={classes.ContactusLink} href="tel:+251974760227">
              +251 974760227
            </a>
          </li>
          <li className={classes.ContactusListItem}>
            <img
              src={EmailIcon}
              alt="Envelope Icon"
              className={classes.ContactusListIcon}
            />
            <a
              className={classes.ContactusLink}
              href="mailto:africanhub@gmail.com"
            >
              africanhub@gmail.com
            </a>
          </li>
        </ul>
      </div>

      {/*  TEMP */}
      <div className={classes.Map}>
        <Map />
      </div>
      {/* TEMP */}
      <Footer />
    </section>
  );
}

export default Contactus;
